import { deviceApi } from '@accedo/ctv-device-api';
import { logger } from '@accedo/logger';
import { DeviceInfo } from '##/dataModels/deviceInfo';

const UNKNOWN = 'Unknown';
const platform: string = process.env.APP_PLATFORM || 'Unknown';
let cachedDeviceInfo: DeviceInfo;

export const getScreenWidth = (): number => Math.min(window.innerWidth, window.screen.width);
export const getScreenHeight = (): number => Math.min(window.innerHeight, window.screen.height);

export const getDeviceInfo = async (): Promise<DeviceInfo> => {
  if (cachedDeviceInfo) {
    return cachedDeviceInfo;
  }
  const deviceInfo: DeviceInfo = {
    deviceId: '',
  };
  deviceInfo.deviceName = platform;
  // @ts-expect-error allow for unknown type also.
  deviceInfo.deviceType = deviceApi.device.type ? (await deviceApi.device.type()).toLowerCase() : UNKNOWN;
  deviceInfo.model = deviceApi.device.model ? await deviceApi.device.model() : UNKNOWN;
  const deviceId = deviceApi.device.id ? await deviceApi.device.id() : UNKNOWN;
  deviceInfo.deviceId = deviceId;
  const deviceMake = deviceApi.device.make ? await deviceApi.device.make() : undefined;
  const deviceOperator = deviceApi.device.operator ? await deviceApi.device.operator() : undefined;
  deviceInfo.operator = deviceOperator;
  deviceInfo.manufacturer = deviceMake || deviceOperator || UNKNOWN;
  deviceInfo.os = deviceApi.device.platform ? await deviceApi.device.platform() : UNKNOWN;
  deviceInfo.osVersion = deviceApi.device.firmwareVersion ? await deviceApi.device.firmwareVersion() : UNKNOWN;
  deviceInfo.userAgent = navigator.userAgent || UNKNOWN;
  deviceInfo.extraInfo = {
    screenWidth: getScreenWidth(),
    screenHeight: getScreenHeight(),
    connectionType: deviceApi.network?.connectionType ? await deviceApi.network.connectionType() : UNKNOWN,
    language: deviceApi.localization?.language ? await deviceApi.localization.language() : UNKNOWN,
    locale: deviceApi.localization?.locale ? await deviceApi.localization.locale() : UNKNOWN,
    countryCode: deviceApi.localization?.countryCode ? await deviceApi.localization.countryCode() : UNKNOWN,
    adId: deviceApi.advertising?.id ? await deviceApi.advertising.id() : UNKNOWN,
    dolbyAtmos: deviceApi.features?.dolbyAtmos ? await deviceApi.features?.dolbyAtmos() : false,
    serial: deviceApi.device.serial ? await deviceApi.device.serial() : UNKNOWN,
  };
  cachedDeviceInfo = deviceInfo;
  return deviceInfo;
};

export const logDeviceInfo = async (): Promise<void> => {
  const online = deviceApi.network?.isOnline ? await deviceApi.network.isOnline() : false;
  const deviceState = deviceApi.lifecycle ? deviceApi.lifecycle.state() : UNKNOWN;
  const deviceInfo = await getDeviceInfo();
  const currentDeviceInfo = {
    ...deviceInfo,
  };
  const extraInfo = currentDeviceInfo.extraInfo || ({} as Record<string, unknown>);
  Object.assign(extraInfo, {
    online,
    deviceState,
  });

  try {
    logger.info(`Device Info: \n${JSON.stringify(currentDeviceInfo, null, 2)}\n`);
  } catch (error) {
    logger.error('Error with Device Package', error);
  }
};

export const getAbsolutePath = (route: string): string => {
  const BASE_URL = process.env.PUBLIC_PATH;
  return `${BASE_URL}${route}`.replace(/\/\//g, '/');
};

export const checkNetworkConnection = async (): Promise<boolean> => {
  try {
    const network = await fetch(getAbsolutePath('/assets/ping/ping.json'))
      .then((res) => res.json())
      .then((resJSON) => resJSON);

    return network.ping;
  } catch (err) {
    logger.error(err);
    return false;
  }
};
